/* MARVI OCEAN - Ocean Encyclopedia AI fallback.
 *
 * The corpus answers first. This only runs when nothing matches.
 * Until WORKER_URL is set, the search simply says it has no sourced answer.
 *
 * To switch it on: deploy the Cloudflare Worker, then paste its URL below.
 */
(function(){
'use strict';
var OJ = window.OJ = window.OJ || {};

/* PASTE YOUR WORKER URL HERE, e.g.
   var WORKER_URL = "https://marvi-ocean-search.yourname.workers.dev"; */
var WORKER_URL = "";

OJ.aiEnabled = function(){ return !!WORKER_URL; };

var cacheKey = 'marvi-oj-ai-cache';
function readCache(){
  try { return JSON.parse(sessionStorage.getItem(cacheKey) || '{}'); } catch(e){ return {}; }
}
function writeCache(c){
  try { sessionStorage.setItem(cacheKey, JSON.stringify(c)); } catch(e){}
}

OJ.ask = function(question){
  if(!WORKER_URL) return Promise.resolve(null);

  var key = question.toLowerCase().trim();
  var cache = readCache();
  if(cache[key]) return Promise.resolve(cache[key]);

  var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
  var timer = setTimeout(function(){ if(ctrl) ctrl.abort(); }, 15000);

  return fetch(WORKER_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question: question }),
    signal: ctrl ? ctrl.signal : undefined
  })
  .then(function(r){
    clearTimeout(timer);
    if(r.status === 429) return { error: 'busy' };
    if(!r.ok) return { error: 'failed' };
    return r.json();
  })
  .then(function(d){
    if(!d || d.error || !d.answer) return d && d.error === 'busy' ? { error: 'busy' } : null;
    cache[key] = d.answer;
    writeCache(cache);
    return d.answer;
  })
  .catch(function(){ clearTimeout(timer); return null; });
};
})();
